import axios from 'axios';

export const PRIMARY_LOCALE = 'fr-FR';

export const isNotFoundError = (error: unknown): boolean =>
  axios.isAxiosError(error) && error.response?.status === 404;

export const logMissingResource = (resource: string, locale: string) => {
  // eslint-disable-next-line no-console
  console.warn(`[${resource}] Not found for locale "${locale}", skipping.`);
};
